import { h, Component } from 'preact';
import { trackingProvider, STANDARD_KEYS } from '@cube/track';
import { TaboolaJs } from '../../taboola-js';

export const canRender = () => true;
export const getLink = ({ uri }) => uri;

@trackingProvider({
	[STANDARD_KEYS.cubecomponent]: 'TaboolaJs.Sponsored'
})
export class Card extends Component {

	render({ slideNumber }) {
		let id = `taboola-dcc-${slideNumber}`;
		let config = {
			taboolaJsParams: {
				mode: 'thumbnails-r',
				container: id,
				placement: `dcc-slide${slideNumber}-js-v2`,
				target_type: 'mix'
			},
			id
		};
		return 	(
			<TaboolaJs {...config} qeId="dcc-taboola-card" data-tb-region-item />
		);
	}
}

const Taboola = {
	canRender,
	getLink,
	Card
};
export default Taboola;



// WEBPACK FOOTER //
// ../node_modules/@cube/dcc-widget-v2/src/components/cards/taboola-sponsored/index.js